import styled from "styled-components";
import { Paper } from "@material-ui/core";

export const Container = styled(Paper)`
  max-width: 22.7rem;
  padding: 0px;
  margin: 0px;
  margin-bottom: 10px;

  .MuiCardHeader-root {
    padding-bottom: 0px;
  }

  .MuiCardContent-root {
    padding-top: 0px;
  }

  .MuiCardHeader-title {
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
  }

  .header {
    :hover {
      cursor: pointer;
    }
  }

  .react-tel-input {
    margin-bottom: 20px;
  }
`;
